import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setZoneData } from 'Store/Zone/action';
import { langCheck, debounce } from 'Pub/js/utils';
import { updateAreaList, updateSaveFlag, setZoneDataFun, updateAreaValidate } from 'Store/ZoneSetting/action';
import platform from "Pub/js/platform";
const { getLangCode } = platform;

require('./index.less');

require('./wbs.less');

const { NCSelect, NCFormControl } = platform.base;
const NCOption = NCSelect.NCOption;

const toLocaleLowerCase = function (str) {
    return String(str).toLocaleLowerCase();
};

/**
 * 区分大小写之后还需要获取原始字符
 */
const getOriginalStr = function (str, key) {
    let res = String(str).match(new RegExp(`${key}`, 'ig'));
    return res ? res[0] : '';
};

class SearchBox extends Component {
    constructor(props) {
        super(props);
        this.sourceData = props.sourceData || [];
        this.state = {
            select: 'All',
            key: '',
            current: 1,
            total: 0,
            // 也可以自行计算
            selectOptions: props.selectOptions || [],
        };
        // 动作锁
        this.lock = false;
    }

    componentDidMount() {
        let { selectOptions = [], relations } = this.handleSourceData();
        this.relations = relations;
        this.setState({ selectOptions });
    }

    componentWillReceiveProps(nextProps) {
        let { sourceData } = nextProps;
        // if (sourceData != this.sourceData) {
        this.sourceData = sourceData;
        let { selectOptions = [], relations } = this.handleSourceData();
        this.relations = relations;
        // console.log('wbs search from', relations, sourceData);
        this.setState({ selectOptions }, () => {
            if (nextProps.reseek) {
                this.search(this.state.key, this.state.current);
            }
            if (nextProps.clear) {
                this.clear();
            }
        });
        // }
    }

    componentWillUnmount() {
        this.sourceData = [];
    }

    // 为了减少遍历 数据处理 单独提取
    handleSourceData() {
        let sourceData = this.sourceData,
            relations = {},
            selectOptions = [];
        // console.log('wbs sourceData for', relations, selectOptions);
        return { relations, selectOptions };
    }

    // 定位
    select = (index = 1) => {
        let { onSelect } = this.props,
            { highlights } = this.state,
            current = highlights[index - 1];
        onSelect && onSelect(current, current ? current.index : 0);
    }

    /**
     * 处理高亮数据的格式  为{pcode: {code: {..}}}
     * @param {*} highlights
     */
    handleHighlights(highlights = []) {
        let res = {};
        highlights.forEach(ele => {
            let { code } = ele;
            res[code] = {
                ...(res[code] || {}),
                ...(ele[code] || {}),
            };
        });
        return res;
    }

    // 高亮
    active = () => {
        let { onActive } = this.props,
            { highlights } = this.state;
        onActive && onActive(this.handleHighlights(highlights));
    }

    /**
     * 清理所有的已选项
     */
    clearAllHightLight() {
        let { onClear } = this.props,
            { highlights } = this.state;
        onClear && onClear();
    }

    getMultiLangName(ele, propertyKey) {
        let { multiOptions } = this.props;
        let local = getLangCode('langCode');
        let localTitle = '';
        let mainTitle = '';
        let itemKey = '';
        let ret;
        if (!multiOptions) {
            return _.get(ele, name, '');
        }
        multiOptions.forEach(opt => {
            let { languageMain, index, languageCode } = opt;
            itemKey = `${propertyKey}${index}`;
            if (languageCode === local) {
                localTitle = _.get(ele, itemKey);
            }
            if (languageMain === true) {
                mainTitle = _.get(ele, itemKey);
            }
        });
        ret = localTitle && localTitle.length > 0 ? localTitle : mainTitle;
        return ret;
    }

    // 查找
    search = (key, index = 1) => {
        let highlights = [],
            searchData = this.sourceData,
            searchKey = (this.props.searchKey || [])[0]; // 后续扩展用
        key && searchData.forEach(ele => {
            let { code, data } = ele;
            // 查找对应数据
            data.forEach((item, index) => {
                let { label = '', code: icode } = item;
                let localLabel = this.getMultiLangName(item, 'label');
                if (toLocaleLowerCase(label).indexOf(toLocaleLowerCase(key)) != '-1' ||
                    toLocaleLowerCase(localLabel).indexOf(toLocaleLowerCase(key)) !== -1
                ) {
                    // 侧边模式  和非侧边模式
                    // ((!showSide && areastatus != 'edit') || showSide)
                    highlights.push({
                        // 避免自身数据和 子数据混乱 加入区分
                        [code]: {
                            [icode]: {
                                code: icode,
                                activeCls: ' wbs-search-units-active ',
                                selectCls: ' wbs-search-units-selected ',
                                key: getOriginalStr(localLabel, key),
                                name: 'label',
                                value: localLabel,
                                index,
                            },
                        },
                        code,
                        index,
                    });
                }
            });
        });
        console.log('wbs search res', highlights, this.handleHighlights(highlights));
        this.setState({
            highlights,
            current: index,
            total: highlights.length,
            key,
        }, () => {
            // 清理上次已选
            this.clearAllHightLight();
            this.active();
            this.select(index);
        });
    }

    /**
     * 输入查询
     */
    handleChange = key => {
        this.search(key);
        this.setState({ key });
    }

    /**
     * 清空按钮事件
     */
    clear = () => {
        this.clearAllHightLight();
        this.setState({
            key: '',
            current: 1,
            total: 0,
        });
    }

    /**
     * 上一个
     */
    prev = () => {
        let { highlights, current, total = -1 } = this.state;
        if (total <= 0 || !highlights.length || this.lock) {
            return;
        }
        current = current === 1 ? total : current - 1;
        this.select(current);
        this.setState({ current });
    }

    /**
     * 下一个
     */
    next = () => {
        let { highlights, current, total = -1 } = this.state;
        if (total <= 0 || !highlights.length || this.lock) {
            return;
        }
        current = current === total ? 1 : current + 1;
        this.select(current);
        this.setState({ current });
    }

    onSearchInputKeyDown = debounce(keyCode => {
        if (keyCode === 13) {
            this.next();
        }
    }, 20)

    onSearchInputChange = key => {
        this.setState({ key });
        this.handleSearchKey(key);
    }
    handleSearchKey = debounce(key => {
        this.search(key);
    }, 200);

    render() {
        let { current, total, selectOptions, key, select, showSelect = false } = this.state;
        return (
            <div className="search-box with-batch-setting dnd-cancel">

                {showSelect && <NCSelect
                    className="st-select"
                    value={select}
                    showClear={false}
                    fieldid="searchProperty" //自动化测试标记
                    onSelect={value => {
                        this.setState({ select: value }, () => {
                            this.search(key);
                        });
                    }}
                >
                    <NCOption value="All">{langCheck('ZoneSetting-000282', 'pages', this.props.json) || '全部'}</NCOption>
                    {
                        selectOptions.map(ele => <NCOption value={ele.code}><span title={ele.name}>{ele.name}</span></NCOption>)
                    }
                </NCSelect>}
                <NCFormControl
                    className="st-input"
                    placeholder={langCheck('ZoneSetting-000281', 'pages', this.props.json) || '搜索字段名称'}
                    onChange={this.onSearchInputChange}
                    // onBlur={this.handleChange}
                    prefix={<i className="icon iconfont icon-sousuo st-icon-sousuo" />}
                    value={key}
                    fieldid="searchCon" //自动化测试标记
                    onKeyDown={e => {
                        this.onSearchInputKeyDown(e.keyCode);
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                    }}
                />
                {
                    key && <div className="st-count">{`${total ? current : 0}/${total}`}</div>
                }
                {
                    key &&
                    <div className="st-icon">
                        <i className="icon iconfont icon-qingkong st-icon-close" onClick={this.clear} />
                        <i className="icon iconfont icon-jiantoushang1 st-icon-up" onClick={this.prev} />
                        <i className="icon iconfont icon-jiantouxia1 st-icon-down" onClick={this.next} />
                    </div>
                }

            </div>
        );
    }
}

export default SearchBox;
